import { useHistory } from "react-router";
import { IconButton } from "@material-ui/core";
import { useSelector } from "react-redux";
import StatusDot from "../../../../../../Components/status_dot";
import { Popover, Typography } from "@material-ui/core";
import { useState } from "react";
const CoacheeNameRender = (props) => {
  const { rowData } = props;
  const [openAlertAnchor, setOpenAlertAnchor] = useState(null);
  const [openAlertPopover, setOpenAlertPopover] = useState(false);

  // redirection access logic
  const globaluserData = useSelector((state) => state.commonReducer);
  const accessLevels = globaluserData?.userData?.access_level;
  const loggedInJobRole = globaluserData?.userData?.current_job_role;
  const role = globaluserData?.role;
  const history = useHistory();
  let coacheeNameRedirectAccess = false;
  if (role === "admin") {
    coacheeNameRedirectAccess = true;
  }
  if (role === "employee" && Array.isArray(accessLevels)) {
    const selectedAccessLevel = accessLevels
      .filter((e) => e.job_role === loggedInJobRole)[0]
      ?.access_level?.replace(/\s/g, "")
      .toLowerCase();
    if (selectedAccessLevel === "level1") {
      coacheeNameRedirectAccess = true;
    }
  }
  //

  return (
    <>
      <div
        className="center"
        style={{
          position: "relative",
          textAlign: "left",
        }}
      >
        <IconButton
          onClick={(event) => {
            if (rowData.alert_message) {
              setOpenAlertAnchor(event.currentTarget);
              setOpenAlertPopover(true);
            }
          }}
          color="secondary"
          style={{ padding: 0, paddingRight: "6px" }}
        >
          <StatusDot
            variant={
              rowData?.attention_status === "Green" ||
              !rowData?.attention_status
                ? "positive"
                : rowData?.attention_status === "Red"
                ? "negative"
                : "warning"
            }
          />
        </IconButton>

        {coacheeNameRedirectAccess ? (
          <Typography
            onClick={() => {
              const pushParams = {
                pathname: `/admin/organisation/${rowData.organisation_id}/employee/${rowData?.employee_id}/edit`,
                state: { orgName: rowData?.organisation_name || "" },
              };
              if (role === "employee") {
                pushParams.state.unEditable = true;
              }
              history.push(pushParams);
            }}
            // color="primary"
            style={{
              textTransform: "none",
              cursor: "pointer",
              fontSize: "16px",
              fontFamily: "open sans",
              textAlign: "left",
            }}
          >
            {rowData?.coachee_name || ""}
          </Typography>
        ) : (
          <Typography style={{ fontSize: "16px", textAlign: "left" }}>
            {rowData?.coachee_name || ""}
          </Typography>
        )}
      </div>

      {openAlertAnchor && openAlertPopover && (
        <Popover
          anchorOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          style={{ top: "45px", left: "2px" }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          open={openAlertPopover}
          anchorEl={openAlertAnchor}
          onClose={() => {
            setOpenAlertPopover(false);
            setOpenAlertAnchor(null);
          }}
        >
          <Typography
            style={{ padding: "20px" }}
            variant="subtitle1"
            color="secondary"
          >
            {rowData.alert_message}
          </Typography>{" "}
        </Popover>
      )}
    </>
  );
};
export default CoacheeNameRender;
